import * as globals from "../globals";

export const headline = `
  font-family: ${globals.headlineFont};
  font-style: normal;
  font-weight: bold;
  font-size: 1.5rem;
  line-height: 1.15;
  color: #ffffff;
  &:hover {
    color: #01A5FF;
  }`;

export const excerpt = `
  font-family: ${globals.bodyFont};
  font-style: normal;
  font-weight: normal;
  font-size: 0.75rem;
  color: #ffffff;

  p {
    margin: 0;
  }
  
  br {
    display: none;
  }
  `;
